const IcdCodeIcon = (props) => (
  <svg
    width="13"
    height="16"
    viewBox="0 0 13 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.0578 0.259521V2.9421H12.7404L10.0578 0.259521Z"
      fill="#2C2543"
    />
    <path
      d="M9.61518 3.8276C9.37063 3.8276 9.17237 3.62934 9.17237 3.38479V0H2.65114C1.68363 0 0.896484 0.787142 0.896484 1.75466V13.36C0.896484 14.3275 1.68363 15.1146 2.65114 15.1146H11.2453C12.2129 15.1146 13 14.3275 13 13.36V3.8276H9.61518ZM10.6567 13.2089H3.26213C3.01758 13.2089 2.81932 13.0107 2.81932 12.7661C2.81932 12.5216 3.01758 12.3233 3.26213 12.3233H10.6567C10.9013 12.3233 11.0995 12.5216 11.0995 12.7661C11.0995 13.0107 10.9013 13.2089 10.6567 13.2089ZM2.81932 11.1425C2.81932 10.8979 3.01758 10.6997 3.26213 10.6997H9.11459C9.35914 10.6997 9.55741 10.8979 9.55741 11.1425C9.55741 11.387 9.35914 11.5853 9.11459 11.5853H3.26213C3.01758 11.5853 2.81932 11.387 2.81932 11.1425ZM10.6567 10.0369H3.26213C3.01758 10.0369 2.81932 9.83865 2.81932 9.5941C2.81932 9.34955 3.01758 9.15129 3.26213 9.15129H10.6567C10.9013 9.15129 11.0995 9.34955 11.0995 9.5941C11.0995 9.83865 10.9013 10.0369 10.6567 10.0369ZM2.81932 8.0295C2.81932 7.78495 3.01758 7.58669 3.26213 7.58669H9.77108C10.0156 7.58669 10.2139 7.78495 10.2139 8.0295C10.2139 8.27405 10.0156 8.47231 9.77108 8.47231H3.26213C3.01758 8.47231 2.81932 8.27405 2.81932 8.0295ZM10.6567 6.8944H3.26213C3.01758 6.8944 2.81932 6.69614 2.81932 6.45159C2.81932 6.20704 3.01758 6.00878 3.26213 6.00878H10.6567C10.9013 6.00878 11.0995 6.20704 11.0995 6.45159C11.0995 6.69614 10.9013 6.8944 10.6567 6.8944Z"
      fill="#2C2543"
    />
  </svg>
);

export default IcdCodeIcon;
